import { render } from "./PDFPageRemover.vue?vue&type=template&id=13ef8780&scoped=true&ts=true"
import script from "./PDFPageRemover.vue?vue&type=script&lang=ts"
export * from "./PDFPageRemover.vue?vue&type=script&lang=ts"

import "./PDFPageRemover.vue?vue&type=style&index=0&id=13ef8780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ef8780"]])

export default __exports__